module.exports = __webpack_public_path__ + "static/media/HIMSSlogo_Hfullcolor_RGB.fdc4df40.png";